import React from "react";
import styled, { keyframes } from "styled-components";
import Header from "../../Header/Header";
import Footer from "../../Footer/Footer";
import SubVisual from "../Public/SubVisual";
import { DHKS_INFO } from "../../../Models/CompanyInfoData";

const animationFadeInUp = keyframes`
  from { opacity: 0; transform: translateY(30px); }
  to { opacity: 1; transform: translateY(0); }
`;

const animationLineHeight = keyframes`
  from { height: 0; }
  to { height: 100%; }
`;

const Greetings = () => {
  return (
    <>
      <Header />
      <SubVisual title="인사말" subTitle="회사소개" />
      <PageContainer>
        <LayoutWrapper>
          <SideSection>
            <div className="sticky-box">
              <div className="vertical-line-wrap">
                <div className="active-line"></div>
              </div>
              <h5 className="label">CEO MESSAGE</h5>
            </div>
          </SideSection>

          <MainSection>
            <HeroTextArea>
              <h2>
                안녕하십니까?
                <br />
                디에이치케이솔루션의 홈페이지를 방문하신
                <br />
                모든 분들께 감사의 말씀을 드립니다.
              </h2>
            </HeroTextArea>

            <BodyTextArea>
              <div className="paragraph-group group-1">
                <p>
                  고객여러분의 사랑과 성원에 힘입어 2006년 일본 DISCO사의 출자
                  법인으로 새롭게 출발한 디에이치케이솔루션은 고객감동을 최우선
                  목표로 전 임직원이 체계적인 고객관리 시스템을 개발하고 기술력
                  및 서비스 능력 향상을 위하여 최선을 다하고 있으며 이를
                  바탕으로 고객의 만족을 넘어 고객 감동을 실현하기 위하여
                  노력하고 있습니다.
                </p>
                <p>
                  저희 디에이치케이솔루션은 우수한 엔지니어와 영업망을 구축하여
                  반도체 제조공정의 Dicing, Grinding, Polishing부분에 있어서
                  제조 장비, Blade & Wheel 및 Application 의 Total Solution 을
                  제공하고 있으며 국내 반도체 산업의 발전과 고객 여러분의 경쟁력
                  향상에 일익을 담당하고 있습니다.
                </p>
              </div>

              <div className="paragraph-group group-2">
                <p>
                  디에이치케이솔루션은 현재의 정밀가공 기술뿐만 아니라 21C
                  반도체 산업의 초일류 선도기업으로 고객 여러분께 미래의
                  정밀가공 기술에 대한 Solution을 제공하기 위해 연구소 및
                  Application Center를 갖추어 반도체 산업의 강국인 대한민국에서
                  반도체 산업의 핵심역할을 담당해 나아갈 수 있는 초석을 다질
                  것입니다.
                </p>
                <p className="final-message">
                  앞으로도 지속적 관심과 애정을 부탁드리고, 저를 비롯한 모든
                  임직원은 고객 만족과 가치 창조를 위하여 최선을 다하며 “고객의
                  행복을 실현시켜드리는 디에이치케이솔루션”이 되도록
                  노력하겠습니다.
                  <br />
                  감사합니다.
                </p>
              </div>
            </BodyTextArea>

            <SignatureArea>
              <div className="signature-box">
                <p className="company" style={{ color: "black" }}>
                  {DHKS_INFO.companyKRName}(주) 대표이사
                </p>
                <p className="name">최 명 배</p>
              </div>
            </SignatureArea>
          </MainSection>
        </LayoutWrapper>
      </PageContainer>
      <Footer></Footer>
    </>
  );
};

export default Greetings;

const PageContainer = styled.div`
  width: 100%;
  min-height: 100vh;
  background-color: #ffffff;
  padding: 200px 0 100px 0;
  @media (max-width: 1200px) {
    padding: 100px 0 100px 0;
  }
`;

const LayoutWrapper = styled.div`
  width: 90%;
  max-width: 1400px;
  margin: 0 auto;
  display: flex;
  gap: 100px;

  @media (max-width: 1200px) {
    gap: 50px;
  }

  @media (max-width: 1024px) {
    flex-direction: column;
    gap: 60px;
  }
`;

const SideSection = styled.div`
  flex: 0 0 120px;
  position: relative;

  .sticky-box {
    position: sticky;
    top: 150px;
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 350px;
  }

  .vertical-line-wrap {
    width: 1px;
    height: 100%;
    background-color: #f0f0f0;
    position: relative;
    overflow: hidden;
  }

  .active-line {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    background-color: #00d2ff;
    animation: ${animationLineHeight} 1.5s ease-out forwards;
  }

  .label {
    writing-mode: vertical-rl;
    text-transform: uppercase;
    font-size: 1rem;
    font-weight: 700;
    letter-spacing: 6px;
    color: #1a1a1a;
    margin-top: 30px;
    opacity: 0;
    animation: ${animationFadeInUp} 0.8s ease-out 0.3s forwards;
  }

  @media (max-width: 1024px) {
    flex: none;
    .sticky-box {
      position: static;
      height: auto;
      flex-direction: row;
      justify-content: flex-start;
      gap: 20px;
    }
    .vertical-line-wrap {
      width: 60px;
      height: 1px;
    }
    .label {
      writing-mode: horizontal-tb;
      margin-top: 0;
    }
  }
`;

const MainSection = styled.div`
  flex: 1;
`;

const HeroTextArea = styled.div`
  margin-bottom: 80px;
  opacity: 0;
  animation: ${animationFadeInUp} 0.8s ease-out 0.5s forwards;

  /* .ornament {
    font-size: 6rem;
    font-family: Georgia, serif;
    color: #00d2ff;
    line-height: 1;
    display: block;
    margin-bottom: -10px;
  } */

  h2 {
    font-size: 3.2rem;
    font-weight: 800;
    color: #1a1a1a;
    line-height: 1.3;
    margin: 0;
    word-break: keep-all;
  }

  @media (max-width: 768px) {
    h2 {
      font-size: 2.2rem;
    }
  }
`;

const BodyTextArea = styled.div`
  display: flex;
  gap: 50px;
  margin-bottom: 120px;
  opacity: 0;
  animation: ${animationFadeInUp} 0.8s ease-out 0.8s forwards;

  .paragraph-group {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 40px;
  }

  p {
    font-size: 1.05rem;
    line-height: 2;
    color: #444;
    margin: 0;
    word-break: keep-all;
    text-align: justify;
  }

  .final-message {
    font-size: 1.15rem;
    font-weight: 600;
    color: #1a1a1a;
    line-height: 2.1;
    padding-left: 25px;
    border-left: 3px solid #00d2ff;
    font-style: italic;
  }

  @media (max-width: 1024px) {
    flex-direction: column;
    gap: 40px;

    .final-message {
      padding-left: 0;
      border-left: none;
      border-top: 2px solid #00d2ff;
      padding-top: 20px;
    }
  }
`;

const SignatureArea = styled.div`
  opacity: 0;
  animation: ${animationFadeInUp} 0.8s ease-out 1.2s forwards;
  display: flex;
  justify-content: flex-end;

  .signature-box {
    text-align: right;
    border-top: 1px solid #1a1a1a;
    padding-top: 30px;
    min-width: 300px;
  }

  .company {
    font-size: 1.1rem;
    color: #888;
    margin-bottom: 10px;
    font-weight: 500;
  }

  .name {
    font-size: 2.5rem;
    font-weight: 800;
    color: #1a1a1a;
    letter-spacing: 8px;
  }
`;
